{
  "api_keys": {
    "title": "API Keys",
    "create_title": "New API Key",
    "create_button": "Create Key",
    "name_label": "Name",
    "name_placeholder": "E.g. Mobile App",
    "prefix_label": "Prefix",
    "permissions_label": "Permissions",
    "last_used": "Last Used",
    "status": "Status",
    "never_used": "Never used",
    "new_key_warning": "Copy this key now. It will not be shown again.",
    "revoke_button": "Revoke",
    "revoke_confirm": "Confirm revocation?",
    "empty": "No API keys",
    "empty_description": "Create an API key to integrate your external systems"
  },
  "permissions": {
    "orders:read": "Read orders",
    "orders:write": "Write orders",
    "products:read": "Read products",
    "customers:read": "Read customers",
    "inventory:read": "Read inventory",
    "webhooks:manage": "Manage webhooks"
  },
  "webhooks": {
    "title": "Webhooks",
    "create_title": "New Webhook",
    "create_button": "Add Webhook",
    "url_label": "Destination URL",
    "events_label": "Events",
    "secret_auto": "A secret will be auto-generated to sign requests.",
    "test_button": "Test",
    "show_deliveries": "Show deliveries",
    "hide_deliveries": "Hide deliveries",
    "delete_button": "Delete",
    "delete_confirm": "Confirm deletion?",
    "failures": "{{count}} failure(s)",
    "last_status": "Last status",
    "empty": "No webhooks",
    "empty_description": "Add a webhook to receive real-time notifications"
  },
  "events": {
    "order.created": "Order created",
    "order.paid": "Order paid",
    "order.shipped": "Order shipped",
    "order.delivered": "Order delivered",
    "order.cancelled": "Order cancelled",
    "payment.confirmed": "Payment confirmed",
    "payment.failed": "Payment failed",
    "stock.low": "Low stock",
    "customer.created": "Customer created"
  },
  "delivery": {
    "title": "Delivery History",
    "timestamp": "Timestamp",
    "event": "Event",
    "status_code": "HTTP Code",
    "response_time": "Response Time",
    "result": "Result",
    "success": "Success",
    "failed": "Failed",
    "empty": "No deliveries recorded"
  },
  "status": {
    "active": "Active",
    "revoked": "Revoked",
    "inactive": "Inactive"
  },
  "actions": {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "copy": "Copy",
    "copied": "Copied!",
    "dismiss": "Dismiss"
  }
}
